module.exports = __webpack_public_path__ + "img/188762d1-41c4-4fcc-88db-b0508d2e67ba.17e1d59b.svg";